module.exports = __webpack_public_path__ + "assets/img/95f9e633b8bb90b200808019a9b20420.png";